module.exports = __webpack_public_path__ + "img/pt-top-bg.402d6549.png";